const BASE = "/risk-scoring/entities";

export const riskEntityReferentialEndpoints = {
  codes: (entity: string) => `${BASE}/${entity}`,
  updateCode: (entity: string, code: string) => `${BASE}/${entity}/${code}`,
  deactivate: (entity: string, code: string) =>
    `${BASE}/${entity}/${code}/deactivate`,
  history: (entity: string) => `${BASE}/${entity}/history`,
  rollback: (entity: string, version: number) =>
    `${BASE}/${entity}/rollback/${version}`,
  importPreview: (entity: string) => `${BASE}/${entity}/import`,
  importConfirm: (entity: string) => `${BASE}/${entity}/import/confirm`,
} as const;
